module.exports = __webpack_public_path__ + "img/member.3567bc49.svg";